export default "__VITE_ASSET__CXXCI7Db__"